module.exports = __webpack_public_path__ + "static/03-44a58fcaa3ac1982aacd33177bec61bb.jpg";